module.exports = __webpack_public_path__ + "img/07.a6675706.png";